import React from 'react'
import {
  Box,
  BoxProps,
  Button,
  HStack,
  Icon,
  VStack,
  Text,
} from '@chakra-ui/react'
import { FaInfoCircle } from 'react-icons/fa'
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '../Popover'

export interface MetricSummaryProps extends BoxProps {
  title: string
  value: string
  popoverHeader?: string
  popoverBody?: string
  borderColor?: string
  valueColor?: string
}

const MetricSummary = ({
  title,
  value,
  popoverHeader,
  popoverBody,
  borderColor = 'blue.900',
  valueColor = 'blue.900',
  ...baseProps
}: MetricSummaryProps) => (
  <Box
    data-testid="metric-summary"
    borderTop="3px solid"
    borderColor={borderColor}
    {...baseProps}
  >
    <VStack alignItems="start">
      <HStack>
        <Text as="h6" textStyle="h4">
          {title}
        </Text>
        {(popoverHeader || popoverBody) && (
          <Popover
            modifiers={[
              {
                name: 'offset',
                options: {
                  offset: [-5, 10],
                },
              },
            ]}
            trigger="click"
          >
            <PopoverTrigger>
              <Button
                variant="link"
                d="inline-block"
                h="1rem"
                minW="1rem"
                lineHeight={0}
                border={0}
                rounded="full"
              >
                <Icon as={FaInfoCircle} color="black" />
              </Button>
            </PopoverTrigger>
            <PopoverContent
              data-testid="popover"
              fontFamily="Inter, Helvetica, Arial, sans-serif"
            >
              <PopoverArrow />
              {popoverHeader && (
                <PopoverHeader>
                  <Text fontSize="md" fontWeight="bold">
                    {popoverHeader}
                  </Text>
                </PopoverHeader>
              )}
              {popoverBody && (
                <PopoverBody>
                  <Text fontSize="md" fontWeight="regular">
                    {popoverBody}
                  </Text>
                </PopoverBody>
              )}
            </PopoverContent>
          </Popover>
        )}
      </HStack>
      <Text as="p" textStyle="h3" color={valueColor}>
        {value}
      </Text>
    </VStack>
  </Box>
)

export default MetricSummary
